import { Component, OnInit, Input } from '@angular/core';
import { IconService } from '../service/icon.service'

@Component({
  selector: 'bcac-index-block',
  templateUrl: './index-block.component.html',
  styleUrls: ['./index-block.component.scss']
})
export class IndexBlockComponent implements OnInit {

  constructor(
    private iconService: IconService
  ) { }

  ngOnInit() {
  }
  dataList = []
  @Input()//颜色
  set bcacDataList(value) {
    for (const iterator of value) {
      iterator.icon=this.iconService[iterator.icon]
    }
    this.dataList = value;
  }
  spanSize = 7;
  columnWidthValue='31.3%'
  @Input()//颜色
  set columnWidth(value) {
    switch (value) {
      case 'small':
        this.spanSize=5;
        this.columnWidthValue='23%';
        break;
      case 'default':
      this.spanSize=7;
      this.columnWidthValue='31.3%';
        break;
      case 'large':
      this.spanSize=11;
      this.columnWidthValue='48%';
        break;
      default:
        break;
    }
  }
  colorHandel(data) {
    if (data.whetherChangeColor) {
      switch (data.condition) {
        case '>':
          if (data.value > data.range) {
            return data.bgColor;
          } else {
            return '';
          }
        case '<':
          if (data.value < data.range) {
            return data.bgColor;
          } else {
            return '';
          }
        case '>=':
          if (data.value >= data.range) {
            return data.bgColor;
          } else {
            return '';
          }
        case '<=':
          if (data.value <= data.range) {
            return data.bgColor;
          } else {
            return '';
          }
        case '=':
          if (data.value = data.range) {
            return data.bgColor;
          } else {
            return '';
          }
        case '!=':
          if (data.value != data.range) {
            return data.bgColor;
          } else {
            return '';
          }
        default:
          break;
      }
    } else {
      return ''
    }
  }
}
